<template>
    <div v-if="options && options.length > 0">
        <label :for="title" class="base__label container--row">
            <p class="base__label-title">
                {{ title }}
            </p>
            <span
                @mouseover="showImage"
                @mouseleave="showImage"
                class="base__label-info"
            >{{ info }}
            </span>
            <div class="base__label-image">
                <img
                    v-if="postfixImage && active"
                    :src="require('@/assets/icons/' + postfixImage)"
                />
            </div>
        </label>
        <div class="base__input-wrapper selectbox" :class="{'country-height' : forCountry}">
            <img
                v-if="forCountry"
                :src="require('@/assets/icons/' + newPrefixedImage + '.svg')"
                class="base__input-prefix"
                alt="prefix image"
            />
            <div v-if="forCountry">
                <select
                    :name="title"
                    class="selectbox__native"
                    ref="selectbox"
                    v-model="value"
                    @focus="handleFocus"
                    @blur="handleBlur"
                    autofocus
                >
                    <option :value="''" class="selectbox__option">
                        {{ descriptionText }}
                    </option>
                    <option
                        class="selectbox__option"
                        :value="option"
                        :key="index"
                        v-for="(option, index) in options"
                    >
                        {{ option.label || option.name.length > 20 ? `${option.name.slice(0, 18)}...` : option.name }}
                    </option>
                </select>
            </div>
            <div v-else>
                <select
                    :name="title"
                    class="selectbox__native"
                    ref="selectbox"
                    v-model="value"
                    @focus="handleFocus"
                    @blur="handleBlur"
                    autofocus
                >
                    <option :value="''" class="selectbox__option">
                        {{ descriptionText }}
                    </option>
                    <option
                        class="selectbox__option"
                        :value="option"
                        :key="index"
                        v-for="(option, index) in options"
                    >
                        {{ option.label || option.name }}
                    </option>
                </select>
            </div>
            <div class="selectbox__faux" aria-hidden="true">
                <div class="selectbox__placeholder"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeUnmount, computed, ref } from "vue";
import { mapState, injectStore } from "redux-vuex";
import { isPlainObject, SelectBox, getValueFromPath } from "@/support/helpers";
export default {
    name: "PrimarySelect",
    emits: ["value-change"],
    data() {
        return {
            value: "",
            active: false,
        };
    },
    props: {
        descriptionText: {
            type: String,
            required: true,
        },
        defaultValue: {},
        options: {
            type: Array,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        info: {
            type: String,
            default: "",
        },
        postfixImage: {
            type: String,
            required: false,
        },
        inputName: {
            type: String,
            required: true,
        },
        forCountry: {
            type: Boolean,
            default: false,
        },
        prefixImage: {
            type: String,
            default: "",
        },
    },
    watch: {
        value() {
            this.$emit("value-change", this.value);
        },
        defaultValue(newVal) {
            this.value = isPlainObject(newVal) ? Object.assign({}, newVal) : "";
        },
    },
    methods: {
        intialiseFauxSelect: function() {
            // SelectBox class
            // Instantiate a new select box
            new SelectBox(this.$refs.selectbox);
        },
        showImage: function() {
            this.active = !this.active;
        },
    },
    updated() {

        if (this.$refs.selectbox) {
            if (this.$refs.selectbox.selectedIndex < 0) {
                this.value = "";
                return; 
            }
            this.intialiseFauxSelect();
        }
    },
    mounted() {
        this.value = isPlainObject(this.defaultValue)
            ? Object.assign({}, this.defaultValue)
            : "";

        if (this.$refs.selectbox) {
            this.intialiseFauxSelect();
        }
    },
    setup(props) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const selectbox = ref(null);
        const isFocused = ref(false);

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        function handleFocus() {
            const data = {
                name: props.inputName,
                label: `${props.title}`,
                value: selectbox.value.value,
            };
            checkoutData.value.view.context.$actions.focusin(data);
        }
        function handleBlur() {
            const data = {
                name: props.inputName,
                label: `${props.title}`,
                value: selectbox.value && selectbox.value.value ? selectbox.value.value : "",
            };
            checkoutData.value.view.context.$actions.focusout(data);
        }
        const newPrefixedImage = computed(() => {
            let logo = "";
            if (isFocused.value) {
                logo = `${props.prefixImage}-light`;
            }
            else {
                logo = props.prefixImage;
            }
            return logo;
        });
        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                context: (state) => getValueFromPath(state, "view.context") || {},
            }),
            selectbox,
            newPrefixedImage,
            handleBlur,
            handleFocus,
        };
    },
};
</script>

<style lang="scss" scoped>
.selectbox {
  --border-color: #dbdbdb;
  /* --border-radius: 4px; */
  --border-width: 1px;
  height: 40px;
  contain: strict;
  overflow: hidden;
  position: relative;
  /* border-radius: var(--border-radius); */
  border-bottom: var(--border-width, 1px) solid var(--border-color, transparent);
  /* margin: 100px auto; */
  background: transparent;
  font-family: $font-primary;
}
.selectbox__native,
.selectbox__faux {
  --box-offset: calc(var(--border-width, 1px) * -1);
  --box-size: calc(100% + var(--border-width, 1px) * 2);
  top: var(--box-offset);
  left: var(--box-offset);
  width: var(--box-size);
  height: var(--box-size);
  position: absolute;
  border-radius: inherit;
font-family: $font-primary;
}
.selectbox__native {
  text-indent: -9999px;
  appearance: none;
  z-index: 999999;
  opacity: 0;
}
.selectbox__option{
    font-family: $font-primary !important;
}

.selectbox__faux {
  color: #828282;
  padding: 0 0.75rem;
  display: flex;
  font-family: $font-primary;
}

.selectbox__icon,
.selectbox__placeholder,
.selectbox__faux::after {
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  line-height: 1.9rem;
}

.selectbox__faux::after {
  content: "";
  width: 1px;
  height: 1px;
  order: 9999;
  align-self: center;
  margin-left: 0.625rem;
  border-top: 5px solid #999999;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.selectbox__icon.icon--end {
  order: 3;
  margin-left: 0.625rem;
}

.selectbox__placeholder {
  order: 2;
  font-weight: 500;
  flex: auto;
  font-family: $font-primary;
}
label {
  position: relative;
}
.country-height {
    height: 32px;
    border-bottom:  0.946925px solid #e4ecf3;

    .selectbox__faux {
        color: #0F273F;
        padding: 0 2.5rem;
        display: flex;
        font-family: $font-primary;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        font-size: 1.6rem;
    }
}
</style>